import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { makeStyles } from '@material-ui/core/styles';
import { addRemoveRequest, deleteRemoveRequest } from 'utility/general';
import usePrevious from 'hooks/usePrevious';
import { checkNull } from 'utility/formValidate';

const SLayout = styled.div`
    min-width: 80px;
`;

const SErrorLayout = styled.div`
    margin: 10px 0 0 10px;
    font-size: 12px;
    color: red;
`;

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const CustomOutlineSelect = ({
    value,
    choices = [{ display: 'Test', key: 'test', isDisabled: false }],
    label = '',
    name = '',
    style = {},
    size = 'normal',
    onChange = (e) => null,
    isRequired = false,
    isValidValue = (isValid) => null,
    disableOnPermission = false,
    showEmptyChoice = true,
    forceErrorDisplay = false,
    allowAction = true,
    updateSiteFormOnDisableChange = -1, // site-info id
    updateApplicationFormOnDisableChange = -1,
    onAppFieldValidate,
    disabled,
}) => {
    const classes = useStyles();
    const previousDisable = usePrevious(`${allowAction}`);
    const [showError, setShowError] = useState(false);
    // update to application when disabled property change
    useEffect(() => {
        // updateApplicationFormOnDisableChange = application id
        if (previousDisable && (updateApplicationFormOnDisableChange >= 0 || updateSiteFormOnDisableChange >= 0)) {
            if (!name) {
                throw new Error('name is required');
            }
            const isDisabled = getDisableExceptionPermission();
            if (isDisabled) {
                addRemoveRequest({
                    applicationFormId: updateApplicationFormOnDisableChange,
                    name: name,
                    siteInfoId: updateSiteFormOnDisableChange,
                });
            } else {
                deleteRemoveRequest({
                    applicationFormId: updateApplicationFormOnDisableChange,
                    keys: [name],
                    siteInfoId: updateSiteFormOnDisableChange,
                });
            }
        }

        checkAppFieldValidate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allowAction, disabled]);

    const checkAppFieldValidate = () => {
        if (onAppFieldValidate !== undefined) {
            if (!name) {
                throw new Error('name is required');
            }

            const isDisabled = getDisableExceptionPermission();

            if (isDisabled) {
                onAppFieldValidate(name, true);
            } else {
                if (!checkNull(value)) {
                    onAppFieldValidate(name, true);
                } else {
                    onAppFieldValidate(name, false);
                }
            }
        }
    };

    useEffect(() => {
        if (isRequired && checkNull(value)) {
            isValidValue(false);
            setShowError(true);
        } else {
            isValidValue(true);
            setShowError(false);
        }

        checkAppFieldValidate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, isRequired]);

    const extra = {};

    if (label) {
        extra.label = label;
    }

    const getNullOption = () => {
        if (!showEmptyChoice) {
            return null;
        }

        if (value === '' || value === null || value === undefined) {
            return (
                <MenuItem value={value} disabled>
                    Choose One
                </MenuItem>
            );
        } else {
            return (
                <MenuItem value={''} disabled>
                    Choose One
                </MenuItem>
            );
        }
    };

    const getDisableExceptionPermission = () => {
        if (disabled) {
            return true;
        }

        if (allowAction === false) {
            return true;
        }

        return false;
    };

    const getDisableStatus = () => {
        if (disableOnPermission) {
            return true;
        }

        if (disabled) {
            return true;
        }

        if (allowAction === false) {
            return true;
        }

        return false;
    };

    const getDefaultValue = () => {
        if (value === undefined || value === null) {
            return '';
        }

        return value;
    };

    return (
        <SLayout className={`customSelect${size === 'small' ? ' small' : ''}`} style={style}>
            <FormControl variant="outlined" className={classes.formControl}>
                {label && <InputLabel>{label}</InputLabel>}
                <Select
                    name={name}
                    value={getDefaultValue()}
                    style={{
                        width: '100%',
                        background: getDisableStatus() ? '#f3ebeb' : 'initial',
                        color: getDisableStatus() ? '#000' : 'inherit',
                    }}
                    onChange={onChange}
                    disabled={getDisableStatus()}
                    {...extra}
                >
                    {getNullOption()}
                    {choices.map((item) => {
                        return (
                            <MenuItem key={item.key} value={item.key} disabled={item.isDisabled}>
                                {item.display}
                            </MenuItem>
                        );
                    })}
                </Select>
                {forceErrorDisplay && isRequired && showError && <SErrorLayout>{'This field is required'}</SErrorLayout>}
            </FormControl>
        </SLayout>
    );
};

export default CustomOutlineSelect;
